import React from "react";
import TopHeader from "./TopHeader";
import "./App.sass";
import ErrorBoundary from "../shared/ErrorBoundary";
import { NotificationContainer } from "@abb/abb-common-ux-react";
import notificationStore from "../../flux/stores/shared/NotificationStore";
import INotificationData from "../../models/shared/NotificationData";
import * as CONSTANTS from "../../utilities/Constants";
import { Translation } from "react-i18next";
import loadingIndicatorStore from "../../flux/stores/shared/LoadingStore";
import DateTimeActions from "../../flux/actions/DateTimeActions";
import DateTimeStore from "../../flux/stores/sample/DateTimeStore";

interface IMainLayoutState {
  notifications: any[];
  text: string;
  name: string;
  secondMsg: string;
  isLoading: boolean;
}

export default class MainLayoutNew extends React.Component<
  { location: any },
  IMainLayoutState
> {
  _mount: boolean;
  counter: number;

  constructor(props: { location: any }) {
    super(props);

    this._mount = false;
    this.counter = 0;
    this.state = {
      notifications: [],
      text: "",
      name: "",
      secondMsg: "",
      isLoading: false,
    };
  }

  componentWillUnmount() {
    this._mount = false;
  }
  remove = (id : string) =>{
    const clone = [...this.state.notifications];
    for (let i = 0; i < clone.length; i++) {
      if (clone[i].id === id) {
        clone[i].isClosing = true;
      }
    }
    this.setState({ notifications: clone });
    setTimeout(() => {
      this.setState({ notifications: this.state.notifications.filter((n) => n.id !== id) });
    }, 1000);
  }

  componentDidMount() {
    this._mount = true;

      DateTimeActions.getAll().then(() => {});
      DateTimeStore.on(CONSTANTS.CHANGE_EVENT, (state: any) => {
        const dateObject = state.dateTimeFormatList;
        localStorage.setItem("dateObject", JSON.stringify(dateObject));
      });
    

    notificationStore.on(CONSTANTS.CHANGE_EVENT, (state: INotificationData) => {
      if (this._mount && state) {
        this.counter++;
        const notification = {
          id: `id-${this.counter}`,
          type: "banner",
          buttons:[{ text: 'Close', primary: true, handler: this.remove }],
          severity: [state.severity],
          timeout: CONSTANTS.UI_NOTIFICATION_TIMEOUT,
          text: state.message || '',
        };
        this.setState({ notifications: this.state.notifications.concat(notification) });
      }
    });

    loadingIndicatorStore.on(CONSTANTS.CHANGE_EVENT, (state: any) => {
      if (this._mount) {
        setTimeout(() => {
          this.setState({
            isLoading: state.data,
          });
        }, 2000);
      }
    });
  }
  render() {
    return (
      <Translation>
        {(t) => (
          <>
            <div className="container-fluid header-box fixed-header">
              <TopHeader layout="mainlayout"></TopHeader>
            </div>
            <div className="container-fluid margin-header" >
              <React.Fragment>
                <ErrorBoundary loc={this.props.location}>
                  {this.props.children}
                </ErrorBoundary>
                <NotificationContainer
                  notifications={this.state.notifications}
                  actionHandler={{ remove: () => {} }}
                  style={{
                    top: '-5px',
                    right: "0",
                    zIndex: 10000,
                    width: 490
                  }}
                />
              </React.Fragment>
            </div>
          </>
        )}
      </Translation>
    );
  }
}
